(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketingTrackerNew.DataInput.SalesDataInput",
                {
                    url: "/Sales",
                    component: "salesDataInputComponent",
                    PageTitle: "Sales Data Input | Marketing Tracker",
                });
        }
    ]);

    app.component("salesDataInputComponent",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/MainDataInput/SalesDataInput/sales-data-input.template.html",
            controller: salesDataInputController,
            bindings: {
                today: '<',
                sources: '<',
                advisors: '<',
                statuses: '<',
                linesOfBusiness: '<',
                dateSelect: '<',
                selectedDate: '<',
            }
        });

    salesDataInputController.$inject = ['marketingTrackerSalesTrackerInputApi', '_', '$filter', 'figToaster', '$timeout', 'featureToggleService'];

    function salesDataInputController(marketingTrackerSalesTrackerInputApi, _, $filter, figToaster, $timeout, featureToggleService) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                disableRow: false,
                loadingRows: false,
                columnName: 'Date',
                filterString: '',
                reverseOrder: true,
                table: {
                    header: [
                        {
                            name: 'Date',
                            displayName: 'Date',
                            required: true
                        },
                        {
                            name: 'ClientName',
                            displayName: 'Client',
                            required: true
                        },
                        {
                            name: 'Source.SourceName',
                            displayName: 'Source',
                            required: true
                        },
                        {
                            name: '[Advisors[0].Name, Advisors[1].Name, Advisors[2].Name, Advisors[3].Name]',
                            displayName: 'Advisor',
                            required: true
                        }
                    ],
                    body: []
                },
                model: {
                    Date: $ctrl.today,
                    ClientName: '',
                    Source: '',
                    Advisors: [],
                    LinesOfBusinessAmounts: ng.copy($ctrl.LinesOfBusinessAmounts)
                },
                Indices: resetIndices(),
            });

        var message, toastClass = '';

        function resetIndices() {
            return {
                StartIndex: 0,
                IndexIncrement: 25,
                EndIndex: 0,
                Limit: 50
            };
        }

        $ctrl.increaseLimit = function () {
            $ctrl.Indices.Limit += $ctrl.Indices.IndexIncrement;
        };

        function resetFormModel() {
            $ctrl.form.$setPristine();
            $ctrl.form.$setUntouched();
            $ctrl.model = {
                Date: $ctrl.today.toLocaleDateString(),
                ClientName: '',
                Source: '',
                Advisors: [],
                LinesOfBusinessAmounts: ng.copy($ctrl.LinesOfBusinessAmounts)
            };
        }

        // make copy to compare changes on auto-save
        function copyTable() {
            $ctrl.table.bodyDupe = ng.copy($ctrl.table.body);
        }

        function getRowsByDateRange(selectedDate, enableLoading) {
            $ctrl.loadingRows = enableLoading === 'false' ? false : true;
            var startDate, endDate = null;
            startDate = selectedDate.value.startDate;
            endDate = selectedDate.value.endDate;

            return marketingTrackerSalesTrackerInputApi.getSalesByDate(startDate, endDate)
                .then(function (response) {
                    var copy = ng.copy(response.LineOfBusinessHeaders);
                    $ctrl.table.header.lob = response.LineOfBusinessHeaders
                        .map(function (obj) {
                            return Object.assign(obj, {
                                name: 'LinesOfBusinessAmounts' + '[' + response.LineOfBusinessHeaders.indexOf(obj) + ']' + '.Amount',
                                displayName: obj.LineOfBusinessName,
                                required: false,
                            });
                        });
                    $ctrl.LinesOfBusinessAmounts = copy
                        .map(function (obj) {
                            return Object.assign({}, {
                                LineOfBusinessId: obj.Id,
                                LineOfBusinessName: obj.LineOfBusinessName,
                                Amount: 0,
                            });
                        });
                    $ctrl.LinesOfBusinessAmounts = $filter('orderBy')($ctrl.LinesOfBusinessAmounts, 'LineOfBusinessName', false);
                    $ctrl.table.header.lob = $filter('orderBy')($ctrl.table.header.lob, 'displayName', false);
                    $ctrl.table.body = response.SaleModels;
                    $ctrl.model.LinesOfBusinessAmounts = ng.copy($ctrl.LinesOfBusinessAmounts);
                    copyTable();
                    $ctrl.loadingRows = false;
                });
        }

        function deleteRow(model) {
            return marketingTrackerSalesTrackerInputApi.deleteSale(model.Id)
                .then(function () {
                    message = 'Row deleted';
                    toastClass = 'is-success';
                    $ctrl.table.body = _.without($ctrl.table.body, model);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later.';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        $ctrl.orderRows = function (columnName) {
            if (columnName) {
                $ctrl.reverseOrder = (columnName === $ctrl.columnName) ? !$ctrl.reverseOrder : false;
                $ctrl.columnName = columnName;
            } else {
                columnName = $ctrl.columnName;
            }
            $ctrl.table.body = $filter('orderBy')($ctrl.table.body, columnName, $ctrl.reverseOrder);
            copyTable();
        };

        $ctrl.filterByDate = function (selectedDateRange) {
            getRowsByDateRange(selectedDateRange)
                .then(function () {
                    $ctrl.orderRows(false);
                });
        };

        $ctrl.addRow = function (model) {
            $ctrl.disableRow = true;
            return marketingTrackerSalesTrackerInputApi.createSale(model)
                .then(function (response) {
                    message = 'New row added';
                    toastClass = 'is-success';
                    $ctrl.addingRow = false;
                    resetFormModel();
                    $ctrl.table.body.unshift(response);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    $ctrl.disableRow = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        };

        $ctrl.toggleEditRow = function (row, index) {
            row.edit = !row.edit;
            $ctrl.table.bodyDupe[index].edit = row.edit;
        };

        $ctrl.updateRow = function (row, form, index, logData) {
            // TODO: Figure out why air-datepicker input on template always trigger a form submission per instance whenever row.edit === true. Uncomment console logs below to see
            // console.log(row, $ctrl.table.bodyDupe[index]);
            // console.log(ng.equals(row, $ctrl.table.bodyDupe[index]));
            // if (logData) console.log(logData);

            if (form.$invalid) return;
            if (ng.equals(row, $ctrl.table.bodyDupe[index])) return;
            else {
                return marketingTrackerSalesTrackerInputApi.updateSale(row)
                    .then(function () {
                        copyTable();
                    })
                    .catch(function () {
                        message = 'Sorry, an error has occurred. Please try again later.';
                        toastClass = 'is-error';
                        getRowsByDateRange($ctrl.selectedDate, 'false');
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            }
        };

        $ctrl.updateLobAmount = function (model, row, form, parentIndex, index) {
            // Since we order the lob amount on the template, we need to order them here to ensure the items match
            var linesOfBusinessAmountsOrdered = $filter('orderBy')($ctrl.table.bodyDupe[parentIndex].LinesOfBusinessAmounts, 'LineOfBusinessName');
            if (form.$invalid) return;
            if (model.Amount == linesOfBusinessAmountsOrdered[index].Amount) return;
            else {
                model.Amount = !!model.Amount ? model.Amount : '0.00';
                return marketingTrackerSalesTrackerInputApi.updateSaleLobAmounts(row.Id, model)
                    .then(function () {
                        copyTable();
                    })
                    .catch(function () {
                        message = 'Sorry, an error has occurred. Please try again later.';
                        toastClass = 'is-error';
                        getRowsByDateRange($ctrl.selectedDate, 'false');
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            }
        }

        // ng-blur & ng-change changes how things are fired. FYI
        $ctrl.updateCell = function (row, cellName, index, parentIndex) {
            if (parentIndex) {
                console.log('Not implemented'); // TODO: Use parentIndex when refactoring to handle nested arrays such as lob amounts
            } else {
                if (ng.equals(row[cellName], $ctrl.table.bodyDupe[index][cellName])) return;
                else {
                    return marketingTrackerSalesTrackerInputApi['updateSale' + cellName](row.Id, row[cellName])
                        .then(function () {
                            copyTable();
                        })
                        .catch(function () {
                            message = 'Sorry, an error has occurred. Please try again later.';
                            toastClass = 'is-error';
                            getRowsByDateRange($ctrl.selectedDate, 'false');
                            return figToaster.showSimple(message, "top", toastClass);
                        });
                }
            }
        };

        $ctrl.deleteWithUndo = function (model) {
            model.showUndo = true;
            model.deferDelete = $timeout(function () {
                deleteRow(model, index);
            }, 1800);
            return deleteRow(model);
        };

        $ctrl.undoDeleteRow = function (model) {
            $timeout.cancel(model.deferDelete);
            model.showUndo = false;
        };

        $ctrl.deleteRow = function (model) {
            return marketingTrackerSalesTrackerInputApi.deleteSale(model.Id)
                .then(function () {
                    message = 'Row deleted';
                    toastClass = 'is-success';
                    $ctrl.table.body = _.without($ctrl.table.body, model);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later.';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    return figToaster.showSimple(message, "top", toastClass);
                });
        };

        $ctrl.$onInit = function () {
            //$ctrl.selectedDate = $ctrl.dateSelect[0];
            getRowsByDateRange($ctrl.selectedDate).then(function () {
                $ctrl.orderRows(false);
            });
        };

        $ctrl.export = function (selectedDate) {
            var startDate, endDate = null;
            startDate = selectedDate.value.startDate;
            endDate = selectedDate.value.endDate;
            marketingTrackerSalesTrackerInputApi.postExportSales(startDate, endDate).then(function (data) {
                var objectUrl = URL.createObjectURL(data);
                var a = document.createElement("a");
                a.style = "display:none";
                a.href = objectUrl;
                a.download = "Sales.xlsx";
                a.click();
            });
        };

        $ctrl.chekForNullAmount = function (lob) {
            if (!lob.Amount) {
                lob.Amount = 0;
            }
        }
    }
})(window.app, window.angular);